// import React, { useState, useEffect } from 'react';
// import './TransactionBookList.css';
// import * as Constants from '../../Constant/constant';

// function TransactionBookList() {
//     const [showTransactionBookList, setShowTransactionBookList] = useState(true);
//     const [selectedLibraryTransaction, setSelectedLibraryTransaction] = useState('');
//     const [bookStatusTransaction, setBookStatusTransaction] = useState('');
//     const [transactionBooks, setTransactionBooks] = useState([]);
//     const [loadingTransactionBooks, setLoadingTransactionBooks] = useState(false);
//     const [errorTransactionBooks, setErrorTransactionBooks] = useState(null);
//     const [transactionCount, setTransactionCount] = useState(0);
//     const [totalFine, setTotalFine] = useState(0);
//     const [totalIssuedBooks, setTotalIssuedBooks] = useState(0);
//     const [entriesToShowTransaction, setEntriesToShowTransaction] = useState(10);
//     const [searchQueryTransaction, setSearchQueryTransaction] = useState('');
//     const [libraries, setLibraries] = useState([]);
//     const [loadingLibraries, setLoadingLibraries] = useState(true);
//     const [errorLibraries, setErrorLibraries] = useState('');
//     const [entriesToShowLibraries, setEntriesToShowLibraries] = useState(10);
//     const [searchQueryLibraries, setSearchQueryLibraries] = useState('');

//     const fetchTransactionBookList = async () => {
//         setLoadingTransactionBooks(true);
//         setErrorTransactionBooks(null);
//         try {
//             const response = await fetch(Constants.API_PATH +'/transaction_book_list');
//             if (!response.ok) {
//                 throw new Error('Failed to fetch transaction books');
//             }
//             const data = await response.json();
//             setTransactionBooks(data.books);
//             setTransactionCount(data.count);
//             setTotalFine(data.totalFine);
//             setTotalIssuedBooks(data.totalIssuedBooks);
//         } catch (error) {
//             setErrorTransactionBooks(error.message);
//         } finally {
//             setLoadingTransactionBooks(false);
//         }
//     };

//     const fetchLibraries = async () => {
//         setLoadingLibraries(true);
//         setErrorLibraries('');

//         try {
//             const response = await fetch(Constants.API_PATH +`/add_new_library_data`); // Replace with your API endpoint
//             if (!response.ok) {
//                 throw new Error(`Failed to fetch libraries: ${response.status}`);
//             }
//             const data = await response.json();
//             setLibraries(data);
//         } catch (error) {
//             console.error('Error fetching libraries:', error);
//             setErrorLibraries('Failed to fetch libraries. Please check the console for details.');
//         } finally {
//             setLoadingLibraries(false);
//         }
//     };


//     const handleLibraryChangeTransaction = (e) => {
//         setSelectedLibraryTransaction(e.target.value);
//     };

//     const handleBookStatusChangeTransaction = (e) => {
//         setBookStatusTransaction(e.target.value);
//     };

//     const handleEntriesChangeTransaction = (e) => {
//         setEntriesToShowTransaction(e.target.value);
//     };

//     const handleSearchChangeTransaction = (e) => {
//         setSearchQueryTransaction(e.target.value);
//     };

//     useEffect(() => {   
//             fetchLibraries();
//         }, [entriesToShowLibraries, searchQueryLibraries]);

//     return (
//         showTransactionBookList && (
//             <div className="transaction-book-list-section containernew">
//                 <nav className="breadcrumb">
//                     <a href="#" className="breadcrumb-link">Home</a> /
//                     <a href="#" className="breadcrumb-link">Library Management</a> /
//                     <span className="breadcrumb-current">Transaction Book List</span>
//                 </nav>
//                 <h2 className="section-title">Transaction Book List</h2>
//                 <div className="filters">
//                     <div className="filter-group">
//                         <label htmlFor="selectLibraryTransaction" className="form-label">Select Library</label>
//                         <select
//                             id="selectLibraryTransaction"
//                             className="form-select"
//                             value={selectedLibraryTransaction}
//                             onChange={handleLibraryChangeTransaction}
//                         >
//                             <option value="">Select All</option>
//                             {libraries.map((library) => (
//                                 <option key={library.id} value={library.id}>{library.library_name}</option>
//                             ))}
//                         </select>
//                     </div>
//                     <div className="filter-group">
//                         <label htmlFor="bookStatusTransaction" className="form-label">Book Status</label>
//                         <select
//                             id="bookStatusTransaction"
//                             className="form-select"
//                             value={bookStatusTransaction}
//                             onChange={handleBookStatusChangeTransaction}
//                         >
//                             <option value="">Select Status</option>
//                             <option value="issued">Issued</option>
//                             <option value="returned">Returned</option>
//                             <option value="overdue">Overdue</option>
//                         </select>
//                     </div>
//                     <button className="submit-button" onClick={fetchTransactionBookList}>Submit</button>
//                 </div>
//                 <div className="transaction-summary">
//                     <p>Transaction Count: {transactionCount}</p>
//                     <p>Total Fine: ₹{totalFine}</p>
//                     <p>Total Issued Book: {totalIssuedBooks}</p>
//                 </div>
//                 <div className="table-filters">
//                     <div className="entries">
//                         Show
//                         <select value={entriesToShowTransaction} onChange={handleEntriesChangeTransaction} className="form-select">
//                             <option value="10">10</option>
//                             <option value="25">25</option>
//                             <option value="50">50</option>
//                             <option value="100">100</option>
//                             <option value="all">All</option>
//                         </select>
//                         entries
//                     </div>
//                     <div className="search">
//                         Search:
//                         <input
//                             type="text"
//                             className="form-input"
//                             value={searchQueryTransaction}
//                             onChange={handleSearchChangeTransaction}
//                             placeholder="Search..."
//                         />
//                     </div>
//                 </div>
//                 <div className="table-responsive">
//                     {loadingTransactionBooks ? (
//                         <p>Loading Transaction Books...</p>
//                     ) : errorTransactionBooks ? (
//                         <p>{errorTransactionBooks}</p>
//                     ) : (
//                         <table className="custom-table">
//                             <thead>
//                                 <tr>
//                                     <th>Sr. No.</th>
//                                     <th>Name</th>
//                                     <th>Book Name</th>
//                                     <th>Copy Code</th>
//                                     <th>Issue Date</th>
//                                     <th>Due Date of Return</th>
//                                     <th>Actual Date of Return</th>
//                                     <th>Late Days</th>
//                                     <th>Total Amount</th>
//                                     <th>Amount Paid</th>
//                                     <th>Update</th>
//                                     <th>Status</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {transactionBooks.length === 0 ? (
//                                     <tr>
//                                         <td colSpan="13">No data available in table</td>
//                                     </tr>
//                                 ) : (
//                                     transactionBooks.map((transaction, index) => (
//                                         <tr key={index}>
//                                             <td>{index + 1}</td>
//                                             <td>{transaction.name}</td>
//                                             <td>{transaction.bookName}</td>
//                                             <td>{transaction.copyCode}</td>
//                                             <td>{transaction.issueDate}</td>
//                                             <td>{transaction.dueDateOfReturn}</td>
//                                             <td>{transaction.actualDateOfReturn}</td>
//                                             <td>{transaction.lateDays}</td>
//                                             <td>{transaction.totalAmount}</td>
//                                             <td>{transaction.amountPaid}</td>
//                                             <td><button>Update</button></td>
//                                             <td>{transaction.status}</td>
//                                         </tr>
//                                     ))
//                                 )}
//                             </tbody>
//                         </table>
//                     )}
//                 </div>
//                 <div className="pagination">
//                     <button disabled>Previous</button>
//                     <button>Next</button>
//                 </div>
                
//             </div>
//         )
//     );
// }

// export default TransactionBookList;

import React, { useState, useEffect } from 'react';
import './TransactionBookList.css';
import * as Constants from '../../Constant/constant';
import SearchableSelect from '../../shared/SearchableSelect';

function TransactionBookList() {
    const [selectedLibraryTransaction, setSelectedLibraryTransaction] = useState('');
    const [bookStatusTransaction, setBookStatusTransaction] = useState('');
    const [transactionBooks, setTransactionBooks] = useState([]);
    const [transactionCount, setTransactionCount] = useState(0);
    const [totalFine, setTotalFine] = useState(0);
    const [totalIssuedBooks, setTotalIssuedBooks] = useState(0);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [libraries, setLibraries] = useState([]);

    const fetchLibraries = async () => {
        try {
            const response = await fetch(Constants.API_PATH + '/add_new_library_data');
            const data = await response.json();
            setLibraries(data);
        } catch (error) {
            console.error("Error fetching libraries:", error);
        }
    };

    const fetchTransactionBookList = async () => {
        setLoading(true);
        setError('');
        try {
            let url = `${Constants.API_PATH}/transaction_book_list`;

            const params = [];
            if (selectedLibraryTransaction) params.push(`libraryId=${selectedLibraryTransaction}`);
            if (bookStatusTransaction) params.push(`status=${bookStatusTransaction}`);
            if (params.length) url += '?' + params.join('&');

            const response = await fetch(url);
            const data = await response.json();

            setTransactionBooks(data.books || []);
            setTransactionCount(data.count || 0);
            setTotalFine(data.totalFine || 0);
            setTotalIssuedBooks(data.totalIssuedBooks || 0);
        } catch (err) {
            console.error("Error fetching transactions:", err);
            setError('Failed to load data.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchLibraries();
        fetchTransactionBookList(); // fetch default
    }, []);

    return (
        <div className="transaction-book-list-section containernew">
            <nav className="breadcrumb">
                <a href="#" className="breadcrumb-link">Home</a> /
                <a href="#" className="breadcrumb-link">Library Management</a> /
                <span className="breadcrumb-current">Transaction Book List</span>
            </nav>

            <h2 className="section-title">Transaction Book List</h2>

            <div className="filters">
                <div className="filter-group">
                    <label>Select Library</label>
                    <SearchableSelect
                        value={selectedLibraryTransaction}
                        onChange={(e) => setSelectedLibraryTransaction(e.target.value)}
                        options={libraries.map((lib) => ({ value: lib.id, label: lib.library_name }))}
                        placeholder="All Libraries"
                    />
                </div>

                <div className="filter-group">
                    <label>Book Status</label>
                    <SearchableSelect
                        value={bookStatusTransaction}
                        onChange={(e) => setBookStatusTransaction(e.target.value)}
                        options={[
                            { value: 'Issued', label: 'Issued' },
                            { value: 'Returned', label: 'Returned' }
                        ]}
                        placeholder="All"
                    />
                </div>

                <button className="submit-button" onClick={fetchTransactionBookList}>Submit</button>
            </div>

            <div className="transaction-summary">
                <p>Transaction Count: <strong>{transactionCount}</strong></p>
                <p>Total Fine: ₹<strong>{totalFine}</strong></p>
                <p>Total Issued Books: <strong>{totalIssuedBooks}</strong></p>
            </div>

            <div className="table-responsive">
                {loading ? (
                    <p>Loading transaction books...</p>
                ) : error ? (
                    <p className="error">{error}</p>
                ) : (
                    <table className="custom-table">
                        <thead>
                            <tr>
                                <th>Sr. No.</th>
                                <th>Name</th>
                                <th>Book Name</th>
                                <th>Copy Code</th>
                                <th>Issue Date</th>
                                <th>Due Date</th>
                                <th>Return Date</th>
                                <th>Late Days</th>
                                <th>Total Fine</th>
                                <th>Amount Paid</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {transactionBooks.length === 0 ? (
                                <tr>
                                    <td colSpan="12">No data available</td>
                                </tr>
                            ) : (
                                transactionBooks.map((t, index) => (
                                    <tr key={t.id || index}>
                                        <td>{index + 1}</td>
                                        <td>{t.name}</td>
                                        <td>{t.bookName}</td>
                                        <td>{t.copyCode}</td>
                                        <td>{t.issueDate?.split("T")[0]}</td>
                                        <td>{t.dueDateOfReturn?.split("T")[0]}</td>
                                        <td>{t.actualDateOfReturn?.split("T")[0] || '-'}</td>
                                        <td>{t.lateDays || 0}</td>
                                        <td>₹{t.totalAmount || 0}</td>
                                        <td>₹{t.amountPaid || 0}</td>
                                        <td>{t.status}</td>
                                        <td><button>Update</button></td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
}

export default TransactionBookList;
